
export enum EPCLabel {
    A_PLUS = "A+",
    A = "A",
    B = "B",
    C = "C",
    D = "D",
    E = "E",
    F = "F",

    // ... add more as needed ...
}


export enum WindowAdvice {
    HR_GLASS = "Plaatsen hoogrendementsbeglazing",
    WINDOW_PROFILES = "Plaatsen energiezuinige profielen",
    HR_GLASS_AND_PROFILES = "Plaatsen hoogrendementsbeglazing en energiezuinige profielen",
    UNKNOWN = "Onbekend"
}

export enum AirTightness {
    UNKNOWN = "Onbekend"
}

export enum CoolingAndSummerComfort {
    OK = "Geen oververhitting",
    NOT_OK = "Kans op oververhitting",
    UNKNOWN = "Onbekend"
}

export enum CoolingAndSummerComfortInstallation {
    NO_INSTALLATION = "Geen koel/aircoinstallatie aanwezig",
    UNKNOWN = "Onbekend"
}

export enum LedLighting {
    OK = "LED-verlichting aanwezig",
    NOT_OK = "Geen LED-verlichting aanwezig",
    UNKNOWN = "Onbekend"
}

export enum SanitaryHotWater {
    OK = "Aanwezig",
    COLLECTIVE_INSTALLATION = "Collectieve installatie aanwezig",
    UNKNOWN = "Onbekend"
}

export enum HeatingSystem {
    COLLECTIVE_INSTALLATION_CONDENSING = "Collectieve centrale installatie met condenserende ketel",
    UNKNOWN = "Onbekend"
}

export enum SolarBoiler {
    PRESENT = "Zonneboiler aanwezig",
    NOT_PRESENT = "Geen zonneboiler aanwezig",
    UNKNOWN = "Onbekend"
}

export enum SolarPanels {
    PRESENT = "Zonnepanelen aanwezig",
    NOT_PRESENT = "Geen zonnepanelen aanwezig",
    UNKNOWN = "Onbekend"
}


export enum VentilationSystemType {
    A = "A (Natuurlijke toevoer en afvoer)",
    B = "B (Mechanische toevoer)",
    C = "C (Mechanische afvoer)",
    C_PLUS = "C+ (Mechanische afvoer met vraagsturing)",
    D = "D (Mechanische toevoer en afvoer)",
    NOT_REQUIRED = "Niet verplicht",
    NOT_OK = "Verplicht, maar niet aanwezig",
    UNKNOWN = "Onbekend"
  }

export type EPC = {
    id: any;
    epcLabel: EPCLabel;
    kWh: string;
    createdAt: any;
    expiresAt: any;
    uValueWalls: any;
    uValueGlazing: any;
    uValueWindows: any;
    fileLogId: any;
    fileLog: any;
    extraWallInsulationSqm: number | null;
    extraRoofInsulationSqm: number | null;
    extraFloorInsulationSqm: number | null;
    extraWindowAdvice: WindowAdvice;
    airTightness: AirTightness;
    coolingAndSummerComfort: CoolingAndSummerComfort;
    coolingAndSummerComfortInstallation: CoolingAndSummerComfortInstallation;
    coEmission: string;
    sScore: string;
    ledLighting: LedLighting;
    sanitaryHotWater: SanitaryHotWater;
    heatingSystem: HeatingSystem;
    solarBoiler: SolarBoiler;
    solarPanels: SolarPanels;
    ventilationSystemType: VentilationSystemType; 
}

